import React, { useState, useEffect } from 'react';
import { Row, Col, Container, Form, Button, InputGroup } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import { useProjectName } from '../../../Context/ProjectNameContext';
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import './Style.css';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const projectName = useProjectName();
const [isAccountRecovery, setIsAccountRecovery] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    token: "",
    newPassword: "",
    confirmPassword: ""
  });
  const [passwordError, setPasswordError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const email = queryParams.get('email');
    const token = queryParams.get('token');
  const process = queryParams.get('process');

    if (email && token) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        email: email.split(" ").join("+"),
        token
      }));
    }

      if (process && process.replace(/['"]+/g, "") === "account-recovery") {
    setIsAccountRecovery(true);
  }
  }, [location.search]);

  const validatePassword = (password) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
    return regex.test(password);
  };

  const handleChange = (event) => {
    const { id, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [id]: value
    }));

    if (id === 'newPassword') {
      const isValid = validatePassword(value);
      if (!isValid) {
        setPasswordError('At least 8 characters with upper/lowercase, number, and special character.');
      } else {
        setPasswordError('');
      }
    }
  };

  const handleReset = async () => {
    if (formData.newPassword !== formData.confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }
    if (!validatePassword(formData.newPassword)) {
      setPasswordError('At least 8 characters with upper/lowercase, number, and special character.');
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/auth/reset-password`,
        {
          email: formData.email,
          token: formData.token,
          newPassword: formData.newPassword
        },
        {
          headers: { "Content-type": "application/json" }
        }
      );
      toast.success(response.data.message);
      navigate("/auth/sign-in");
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred while resetting password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="sign-in-page" style={{ height: "100lvh" }}>
        <Container className="p-0 d-flex flex-column align-items-center justify-content-center">
          <div style={{ fontSize: "30px", letterSpacing: "4px", color: "white", fontWeight: "600" }} className={window.innerWidth <= 768 ? "mobile-margin-top" : ""}>
            {projectName}
          </div>
          <Row className="no-gutters justify-content-center" style={{ borderRadius: "10px", overflow: "hidden", margin: "20px" }}>
            <Col md="12" className="bg-white pt-5 pb-5" style={{ width: "400px" }}>
              <div className="sign-in-from px-3">
                {/* <h3 className="mb-0 text-center">Reset Password</h3> */}
                <h3 className="mb-0 text-center">
  {isAccountRecovery
    ? "Recover Account"
    : "Reset Password"}
</h3>
                <h7 className="mb-0 text-center">
  {isAccountRecovery && "Your account has been successfully recovered. Please set a new password."}
</h7>

                <Form className="mt-4">
                  {/* New Password */}
                  <Form.Group className="form-group mb-3">
                    <Form.Label>New Password <span style={{ color: 'red' }}>*</span></Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={showNewPassword ? "text" : "password"}
                        id="newPassword"
                        placeholder="New Password"
                        value={formData.newPassword}
                        onChange={handleChange}
                        required
                      />
                      <Button
                        variant="link"
                        onClick={() => setShowNewPassword(!showNewPassword)}
                        className="eye-button"
                      >
                        {showNewPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
                      </Button>
                    </InputGroup>
                    {passwordError && <div className="text-danger mt-1">{passwordError}</div>}
                  </Form.Group>

                  {/* Confirm Password */}
                  <Form.Group className="form-group mb-3">
                    <Form.Label>Confirm Password <span style={{ color: 'red' }}>*</span></Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={showConfirmPassword ? "text" : "password"}
                        id="confirmPassword"
                        placeholder="Confirm Password"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        required
                      />
                      <Button
                        variant="link"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        className="eye-button"
                      >
                        {showConfirmPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
                      </Button>
                    </InputGroup>
                  </Form.Group>

                  {/* Reset Button */}
                  <div className="d-inline-block w-100">
                    <Button
                      variant="primary"
                      type="button"
                      className="float-end"
                      onClick={handleReset}
                      disabled={loading}
                    >
                      {loading ? "Loading..." : "Reset Password"}
                    </Button>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Toaster position="top-right" reverseOrder={false} />
    </>
  );
};

export default ForgotPassword;
